<div class="image-picker-component">
    <p>{{ 'componente.image-picker.label' | translate }}</p>
    <div class="images-container" ngxUiLoaderBlurred [loaderId]="'loader-image-picker'" [blur]="0">
        <ng-scrollbar orientation="horizontal">
            <div class="images">
                @for (image of images; track image; let i = $index) {
                    @if (!image.isSelected) {
                        <div class="image image-selection"
                            (click)="openFileSelection($event)"
                            (drop)="onDrop($event)"
                            (dragover)="onDragOver($event)"
                            (dragleave)="stopDrag($event)"
                            (dragend)="stopDrag($event)"
                        >
                            <i-feather name="plus"></i-feather>
                        </div>
                        <input accept="image/*" type="file" #fileInput (change)="handleInput($event, i)" [multiple]="dynamicImages" />
                    } @else {
                        <div class="image image-edition">
                            @if (i != 0 && imagesHaveOrder) {
                                <div class="image-chevron image-chevron-left" (click)="changeImageOrderToLeft(i)">
                                    <i-feather name="chevron-left"></i-feather>
                                </div>
                            }
                            <img [src]="'data:image/jpeg;charset=utf-8;base64,' + images[i].imageFile" [alt]="images[i].imageName">
                            <div class="trash-container" (click)="deletePicture(i)">
                                <i-feather name="trash-2" class="trash"></i-feather>
                            </div>
                            @if (i != images.length - 1 && imagesHaveOrder) {
                                <div class="image-chevron image-chevron-right" (click)="changeImageOrderToRight(i)">
                                    <i-feather name="chevron-right"></i-feather>
                                </div>
                            }
                        </div>
                    }
                }
            </div>
        </ng-scrollbar>
        <div class="footer">
            <i-feather name="info" class="info"></i-feather>
            <p>{{ maxSizeAcceptedMessage | translate: { allowedMbs: this.uploadMaxSizeAccepted } }}</p>
        </div>
        <ngx-ui-loader [loaderId]="'loader-image-picker'" [hasProgressBar]="false" [fgsSize]="45"></ngx-ui-loader>
    </div>
</div>
